import { render, staticRenderFns } from "./DeclaracaoNormal.vue?vue&type=template&id=d146203c&scoped=true&"
import script from "./DeclaracaoNormal.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoNormal.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoNormal.vue?vue&type=style&index=0&id=d146203c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d146203c",
  null
  
)

export default component.exports